import { ModalParts } from 'BreetComponents';
import { useFiatWithdrawRequestContext, useUsdWithdrawRequestContext, useWithdrawRequestContext } from 'BreetHooks';

import { requestPaymentStageTitle, requestPaymentUsdStageTitle } from './DialogWithdrawRequest.helpers';
import FiatWithdrawRequest from './forms/fiat/FiatWithdrawRequest';
import UsdWithdrawRequest from './forms/usd/UsdWithdrawRequest';
import Header from './Header';

const Child = () => {
	const { selectedWallet } = useWithdrawRequestContext();

	const { formStage: fiatFormStage } = useFiatWithdrawRequestContext();
	const { formStage: usdFormStage } = useUsdWithdrawRequestContext();

	const formStage = selectedWallet?.currency !== 'USD' ? fiatFormStage : usdFormStage;

	const root =
		selectedWallet?.currency !== 'USD'
			? requestPaymentStageTitle['withdraw-funds']
			: requestPaymentUsdStageTitle['withdraw-funds'];

	return (
		<ModalParts.Wrapper
			title={formStage.stageTitle}
			root={root}
			handleBackLink={formStage.navigator.historyBack}
			rightSheet
		>
			<div
				className='payment-request-form withdraw-request-form'
				data-testid='withdraw-form'
			>
				<Header />

				{selectedWallet?.currency !== 'USD' ? <FiatWithdrawRequest /> : <UsdWithdrawRequest />}
			</div>
		</ModalParts.Wrapper>
	);
};

export default Child;
